// extracted by css-extract-rspack-plugin
export default {"cellContainer":"cellContainer-WV_zJt","cellLink":"cellLink-Ke90qX"};